import builder from '../builder';
import StyleTwoPinHome from '../../streamline-icons/bold/style-two-pin-home.svg';

export default builder('IconStyleTwoPinHomeBold', StyleTwoPinHome);
